module.exports = __webpack_public_path__ + "static/media/bus5.6a4b00ac.jpg";